// @flow
import React, {useEffect} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Alert} from '@homeaway/react-alerts';
import Experiment, {evaluationIsVariant} from '@homeaway/react-experiment';
import {VRBO_SERP_PDP_COVID_BANNER} from '../../abacus/experiments';

import {readCookie, writeCookie} from '../../utils/cookieUtils';
import withLingua from '../withLingua/withLingua';

import type {State as ReduxState} from '../../reducers/index';
import type {LinguaProps} from '../withLingua/withLingua';

import './CovidBanner.less';

type StateProps = {
    isCovidBannerDisabledFromCookie: boolean,
    isCovidExperimentOn: boolean
};
type OwnProps = StateProps & LinguaProps;

const CovidBanner = ({
    isCovidBannerDisabledFromCookie,
    isCovidExperimentOn,
    messages
}: OwnProps) => {
    useEffect(() => {
        if (isCovidExperimentOn && !isCovidBannerDisabledFromCookie) {
            writeCookie('ha_covid_banner_disabled', true, {
                saveAsJson: false,
                daysToExpire: 1
            });
        }
        // This should only run once, so no dependencies are specified purposefully.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const important = messages['traveler.msg.important'];
    const travelerMsg = messages['traveler.msg.covid.policy'];
    const learnMore = messages['traveler.msg.learn.more'];
    const url = messages['traveler.msg.covid.policy.url'];

    const msg = (
        <span>
            <strong>{important} </strong>
            {travelerMsg}

            <a href={`${url}`} target="_blank">
                <strong> {learnMore}</strong>
            </a>
        </span>
    );
    return (
        !isCovidBannerDisabledFromCookie && (
            <Experiment name={'vrbo_serp_pdp_covid_banner'} variant={1}>
                <div className="CovidBanner">
                    <Alert msg={msg} dismissible svgClassName="text-inverse" />
                </div>
            </Experiment>
        )
    );
};

const mapStateToProps = ({
    abacus,
    system: {cookie}
}: ReduxState): StateProps => {
    return {
        isCovidBannerDisabledFromCookie:
            readCookie('ha_covid_banner_disabled', cookie, false) === 'true',
        isCovidExperimentOn: evaluationIsVariant(
            abacus[VRBO_SERP_PDP_COVID_BANNER],
            1
        )
    };
};

const ConnectedCovidBanner = compose(
    connect(mapStateToProps, null),
    withLingua({
        namespace: 'traveler/listing',
        category: 'messages'
    })
)(CovidBanner);

export default ConnectedCovidBanner;
export {CovidBanner};
